import React from "react";
import { Redirect, Route } from "react-router-dom";
import { REGISTER_DETAILS } from "../redux/action_type";
import Header from "../views/common/Header";
import SEO from "../seo";

const PrivateRoute = (props) => {
  const { component: Component, path, ...rest } = props;
  const shouldRender = props.computedMatch.path === path;
  let authData = localStorage.getItem(REGISTER_DETAILS)
  authData = JSON.parse(authData)
  if (authData === null || Object.keys(authData)?.length === 0) {
    return <Redirect to={"/"} />
  }
  if (!shouldRender) return null;
  // const headerRestrictRoutes = ['/store-preview', '/affiliate-dashboard', '/store-online']

  return (
    <React.Fragment>
      {/* {headerRestrictRoutes.includes(window.location.pathname) ? <div className="Test d-none d-md-block"><Header /></div> : <Header />} */}
      <Header/>
      <SEO update={new Date} />
      <Route {...rest} component={Component} />
    </React.Fragment>
  );
};

export default PrivateRoute;
